module.exports = __webpack_public_path__ + "img/20.af5e5efe.png";